export default "__VITE_ASSET__EmPOpllp__"